import { render, staticRenderFns } from "./CoverReport.vue?vue&type=template&id=c9c20ab4"
import script from "./CoverReport.vue?vue&type=script&lang=js"
export * from "./CoverReport.vue?vue&type=script&lang=js"
import style0 from "./CoverReport.vue?vue&type=style&index=0&id=c9c20ab4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports